// 确定过户信息弹窗 TODO: 垃圾，重构
import React from 'react';
import { Provider } from 'react-redux';
import store from '@@/store';
import ReactDOM from 'react-dom';
import { connect } from '@souche-f2e/muji';
import { dispatch } from '@@/store';
import { Modal, Form, Input, Radio, message } from 'antd';
import { Root } from './style';
import AddTransferInfo from './components/AddTransferInfo/index';
import { thousandBitSeparator } from '@/shared/functions';
const mapStateToProps = (rootState, ownProps) => ({
    _state: rootState.transfer,
    params: rootState.router.query
});
class AddModal extends React.Component {
    constructor(props) {
        super(props);
        this.onChangeTransferMoney = (e) => {
            // const { transType } = this.state;
            // const { transferType } = this.props._state
            this.setState({
                transferValue: e.target.value,
            });
        };
        this.onChangeDispate = (e) => {
            this.setState({
                waitValue: e.target.value,
            });
            const { transferDataJson } = this.props._state;
            if (JSON.stringify(transferDataJson) !== '{}') {
                transferDataJson.modelGroup.map((item, index) => {
                    item.picGroup.length = 0;
                });
                dispatch.transfer.SET_STATE({
                    forbiddenButton: false
                });
            }
            dispatch.transfer.CHANGE_VALUE(e.target.value);
        };
        this.onChangeTransfer = (e) => {
            this.setState({
                transferInfoValue: e.target.value,
            });
        };
        this.state = {
            visible: true,
            count: 0,
            transType: 0,
            transferValue: 0,
            waitValue: 0,
            transferInfoValue: 200,
        };
        this.cancel = this.cancel.bind(this);
        this.handleOk = this.handleOk.bind(this);
        this.handleChangeText = this.handleChangeText.bind(this);
        this.onChangeTransferMoney = this.onChangeTransferMoney.bind(this);
        this.renderConfirm = this.renderConfirm.bind(this);
        this.onChangeDispate = this.onChangeDispate.bind(this);
        this.onChangeTransfer = this.onChangeTransfer.bind(this);
    }
    handleChangeText(e) {
        let count = e.target.value.length;
        this.setState({
            count: count
        });
    }
    // parentHide = (e: any) => {
    //   if (e.target === this.outer) {
    //     this.hide();
    //   }
    // }
    commonMethod(props) {
        if (props._state.resource == 1) {
            dispatch.transfer.comfirmTransfer(props.form).then(() => {
                dispatch.transfer.buyTransData(props._state.tempObj);
            });
        }
        else {
            dispatch.transfer.comfirmTransfer(props.form);
        }
        dispatch.transfer.OK();
        this.resetForm();
    }
    handleOk() {
        const props = this.props;
        const { transferType, num } = props._state;
        if (transferType == 30 && num == 1) {
            if (this.state.waitValue === 0) {
                message.warn('请先选择过户类型');
                return;
            }
        }
        if (props._state.num === 1) { //过户类型是否为不限
            if (this.state.transferInfoValue === 200) { //过户方式为是
                if (props._state.picCount > 0) {
                    this.commonMethod(props);
                }
                else {
                    message.warning('请先上传过户信息');
                }
            }
            else {
                this.commonMethod(props);
            }
        }
        else {
            this.commonMethod(props);
        }
    }
    cancel() {
        dispatch.transfer.HIDE();
        this.resetForm();
    }
    resetForm() {
        const props = this.props;
        props.form.resetFields();
        this.setState({
            waitValue: 0,
            transferValue: 0,
            transferInfoValue: 200
        });
        dispatch.transfer.SET_STATE({
            forbiddenButton: false,
            picCount: 0,
            transferDataJson: {}
        });
    }
    renderConfirm(id) {
        const { transferType, num } = this.props._state;
        if (transferType == 30 && num == 1) {
            if (this.state.waitValue === 0) {
                message.warn('请先选择过户类型');
                return;
            }
        }
        dispatch.transfer.SHOW_ADD_MODAL({});
    }
    render() {
        const { transType, waitValue } = this.state;
        const props = this.props;
        const { getFieldDecorator } = props.form;
        const { visible, transferType, lable, num, elasticFrameVisibles, transferFrozenMoney, forbiddenButton, actionType, orderTag } = this.props._state;
        return (<div>
        <Modal title={lable} okText="确认" onOk={this.handleOk} visible={visible} cancelText="取消" maskClosable={false} onCancel={this.cancel} destroyOnClose={true}>
          <Root>
            <Form labelCol={{ span: 7 }} wrapperCol={{ span: 16, offset: 1 }} labelAlign="right">
              {actionType == 10 && orderTag == 1 &&
            <div>
                  <Form.Item label="扣减过户保证金">
                    {getFieldDecorator('isTrue', {
                initialValue: 0,
                rules: [{ required: true }]
            })(<Radio.Group onChange={this.onChangeTransferMoney}>
                        <Radio value={1}>是</Radio>
                        <Radio value={0}>否</Radio>
                      </Radio.Group>)}
                  </Form.Item>
                  {(this.state.transferValue === 1) &&
                <div>
                      <Form.Item label="扣减金额">
                        <span>{thousandBitSeparator(transferFrozenMoney)}元</span>
                      </Form.Item>
                      <Form.Item colon={false} label="备注" className="resetForm">
                        {getFieldDecorator('disputeReason', {
                    rules: [
                        {
                            required: false,
                            message: '请输入备注',
                        },
                        {
                            max: 100,
                            message: '限100字',
                        },
                    ],
                })(<Input.TextArea placeholder="请输入备注" autoSize={{
                    minRows: 4,
                    maxRows: 4,
                }} maxLength={100} onChange={this.handleChangeText} style={{ resize: 'none', border: 'none' }}/>)}
                        <span className="calCount">
                          {this.state.count}/100
                        </span>
                      </Form.Item>
                    </div>}
                </div>}
              
              {transferType == 30 && num == 1 &&
            <Form.Item label="选择过户类型">
                  {getFieldDecorator('disputeInfo', {
                initialValue: 0,
                rules: [{ required: true }]
            })(<Radio.Group onChange={this.onChangeDispate}>
                      <Radio value={10}>本地</Radio>
                      <Radio value={20}>外迁</Radio>
                    </Radio.Group>)}
                </Form.Item>}
              
              {num == 1 &&
            <React.Fragment>
                  <Form.Item label="是否上传过户信息">
                    {getFieldDecorator('isUploadTransferInfo', {
                initialValue: 200,
                rules: [{ required: true }]
            })(<Radio.Group onChange={this.onChangeTransfer}>
                        <Radio value={200}>是</Radio>
                        <Radio value={100}>否</Radio>
                      </Radio.Group>)}
                  </Form.Item>
                  {(this.state.transferInfoValue == 200 && num == 1) ?
                <Form.Item label="过户信息">
                        <a onClick={this.renderConfirm}>添加</a>
                        {forbiddenButton ? <p style={{ color: 'rgba(0, 0, 0, 0.65)' }}>已添加{this.props._state.picCount}个附件</p> : ''}
                      </Form.Item> : ''}
                </React.Fragment>}
            </Form>
          </Root>
        </Modal>
        {elasticFrameVisibles && <AddTransferInfo waitValue={waitValue}/>}
      </div>);
    }
}
const CustomizedForm = Form.create({})(AddModal);
const sellTransInfoWay = connect(mapStateToProps, null, null, { forwardRef: true })(CustomizedForm);
let componentRef = '';
const createInfo = () => {
    const div = document.createElement('div');
    div.className = 'souche--sellTransInfo';
    document.body.appendChild(div);
    const component = (<Provider store={store}>
    {React.createElement(sellTransInfoWay, {
        ref: (ref) => {
            componentRef = ref;
        },
    })}
  </Provider>);
    ReactDOM.render(component, div);
};
export default function SellTransferInfo({ id, goodsId, transferType, actionType, orderTag, actionId, propsCallback }) {
    if (!componentRef) {
        createInfo();
    }
    dispatch.transfer.SHOW({ id, goodsId, transferType, actionType, orderTag, actionId, propsCallback });
}
